/* eslint-disable */
/* tslint:disable */
// @ts-ignore
import icon from 'vue-svgicon'
icon.register({
  'youtube-short': {
    width: 24,
    height: 24,
    viewBox: '0 0 24 24',
    data: '<path pid="0" d="M0 12C0 5.373 5.373 0 12 0s12 5.373 12 12-5.373 12-12 12S0 18.627 0 12Z" _fill="red"/><path pid="1" fill-rule="evenodd" clip-rule="evenodd" d="M13.552 4.813a2.726 2.726 0 0 1 2.724 4.72l-1.243.837c-.069.046-.02.17.063.164a2.726 2.726 0 0 1 1.54 5.079l-6.188 3.573a2.725 2.725 0 1 1-2.725-4.72l1.112-.845c.061-.047.02-.15-.056-.15a2.724 2.724 0 0 1-1.417-5.085l6.19-3.573Zm-2.845 5.266a.15.15 0 0 0-.226.13v3.806a.15.15 0 0 0 .226.131l3.297-1.903a.15.15 0 0 0 0-.26l-3.297-1.904Z" _fill="#fff"/>'
  }
})
